import { useFormikContext } from 'formik';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import { ShareValues } from '../../SharePage/SmsSequence';
import { SmsPreview } from './SmsPreview';

interface Props {
  matchPath: string;
  editRoute: string;
  loading: boolean;
  smsLink?: string;
  displayName?: string;
}

export const SmsPreviewContainer: React.FC<Props> = ({ matchPath, editRoute, loading, smsLink, displayName }) => {
  const { values } = useFormikContext<ShareValues>();
  const match = useRouteMatch(matchPath);

  return (
    <>
      <SmsPreview loading={loading} values={values} smsLink={smsLink} match={match} editRoute={editRoute} />
    </>
  );
};
